import React, { FC } from 'react';
import { Box } from '@mui/material';


export const OfferClients:FC = () => {

  return (
    <Box>
        Dodawanie klientów
    </Box>
  );
};